export default "__VITE_PUBLIC_ASSET__bdf04bcf__"